export const TaskProgressType = Object.freeze({
    STARTED: 'started',
    COMPLETED: 'completed',
    FAILED: 'failed',
    PROCESSING: 'processing',
    CANCELLING: 'cancelling',
    CANCELLED: 'cancelled',
    WARNING: 'warning',
});
